import React, { Component } from "react";
import { Button, Card, Table, Tag } from "antd";
import { connect } from "react-redux";
import axios from "services/axios";

import ModalDetail from "./ModalDetail";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.toggleModalDetail = this.toggleModalDetail.bind(this);
    this.state = {
      loadingTable: true,
      showModalDetail: false,
      modalDetailBooking: {},
      dataSource: [],
      columns: [
        { key: "1", title: "ID", dataIndex: "id" },
        {
          key: "2",
          title: "Details",
          render: (text, record) => (
            <Button onClick={() => this.onClickDetailRecord(record)} icon="bars" style={{ marginRight: 10 }} />
          ),
        },
        {
          key: "3",
          title: "Appraisal",
          render: (text, record) => {
            return record.Appraisal ? this.getStatus(record.Appraisal.status) : this.getStatus("UNASIGNED");
          },
        },
        {
          key: "4",
          title: "Pricing I",
          render: (text, record) => (record.CarInquiry ? this.getStatus("FINISHED") : this.getStatus("WAITING")),
        },
        {
          key: "5",
          title: "Pricing II",
          render: (text, record) =>
            record.CarInquiry && record.CarInquiry.negotiationPrice
              ? this.getStatus("FINISHED")
              : this.getStatus("WAITING"),
        },
        {
          key: "6",
          title: "Negotiation",
          render: (text, record) =>
            !record.CarInquiry
              ? this.getStatus("WAITING")
              : !record.CarInquiry.dealPrice || record.CarInquiry.status === "WAITING_NEGOTIATION"
              ? this.getStatus("WAITING")
              : this.getStatus("FINISHED"),
        },
        {
          key: "7",
          title: "Final Deal",
          render: (text, record) =>
            !record.CarInquiry
              ? this.getStatus("WAITING")
              : record.CarInquiry.status === "DEAL" || record.CarInquiry.status === "NO_DEAL"
              ? this.getStatus(record.CarInquiry.status)
              : this.getStatus("WAITING"),
        },
      ],
    };
  }

  getStatus = status => {
    switch (status) {
      case "WAITING":
        return <Tag color="orange">WAITING</Tag>;
      case "UNASSIGNED":
      case "UNASIGNED":
        return <Tag color="magenta">UNASSIGNED</Tag>;
      case "ASSIGNED":
        return <Tag color="green">ASSIGNED</Tag>;
      case "FINISHED":
        return <Tag color="blue">FINISHED</Tag>;
      case "CANCEL":
        return <Tag color="red">CANCEL</Tag>;
      default:
        return <Tag>{status}</Tag>;
    }
  };

  onClickDetailRecord(record) {
    this.setState({
      showModalDetail: true,
      modalDetailBooking: record,
    });
  }

  toggleModalDetail(bool) {
    this.setState({
      showModalDetail: bool,
    });
  }

  componentDidMount = async () => {
    try {
      let request = await axios.get("/booking/overview");
      this.setState({
        dataSource: request.data.overviews,
        loadingTable: false,
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  render() {
    const { dataSource, columns } = this.state;
    return (
      <React.Fragment>
        <Card title="OVERVIEW">
          <Table 
            pagination={{ pageSize: 100 }}
            rowKey="id" 
            size="small" 
            loading={this.state.loadingTable} 
            columns={columns} 
            dataSource={dataSource} 
            scroll={{ x: 2700, y: 400 }}
          />
        </Card>

        <ModalDetail
          showModalDetail={this.state.showModalDetail}
          dataBooking={this.state.modalDetailBooking}
          toggleModalDetail={this.toggleModalDetail}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(Overview);



// WEBPACK FOOTER //
// src/components/Dashboard/Overview/Overview.js